module.exports = __webpack_public_path__ + "an.no2.06f8af55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/an.no2.jpg
// module id = Qc8r
// module chunks = 0